// PlannerTaskQuickAdd Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Util from '../../../lib/util.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import FieldText from '../../form/field_text/field_text.jsx'
import FieldTitle from '../../form/field_title/field_title.jsx'
import Avatar from '../../../common/common/avatar/avatar.jsx'
import FieldTime from '../../form/field_time/field_time.jsx'
import FormDatePicker from '../../../common/form/form_datepicker/form_datepicker.jsx'
import FieldSelect from '../../form/field_select/field_select.jsx'

class PlannerTaskQuickAdd extends Component {
  constructor (props) {
    super(props)

    this.state = {
      title: '',
      duration: '',
      description: '',
      duedate: '',
      assigneeId: null,
      assignee: '',
      editField: '',
      startDate: new Date()
    }

    this._references = {
      duedate: React.createRef(),
      duration: React.createRef()
    }
  }

  static get propTypes () {
    return {
      activityId: PropTypes.string,
      projectId: PropTypes.string,
      users: PropTypes.array,
      onSave: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      activityId: null,
      projectId: null,
      users: [],
      onSave: null
    }
  }

  componentDidUpdate () {
    if (this._references.duedate.current) {
      this._references.duedate.current.focusInput()
    }

    if (this._references.duration.current) {
      this._references.duration.current.focusInput()
    }
  }

  /* Private Functions */
  _clearState () {
    this.setState({
      title: '',
      duration: '',
      description: '',
      duedate: '',
      assigneeId: null,
      assignee: '',
      editField: ''
    })
  }

  _saveTask () {
    const { projectId, activityId, onSave } = this.props
    const { title, description, duedate, assigneeId } = this.state
    let { duration } = this.state

    if (duration === '') {
      duration = 0
    }

    if (title && onSave) {
      const taskData = {
        title,
        duration,
        projectId,
        activityId,
        description,
        dueDate: duedate || '',
        userId: assigneeId || null
      }

      this._clearState()
      onSave(taskData, () => {
        this._onClickField('title')
      })
    }
  }

  /* Handler Functions */
  _onClickField (name) {
    this.setState({ editField: name })
  }

  _onChangeInput (name, value) {
    this.setState({ [name]: value })
  }

  _onChangeDuration (value) {
    this.setState({ duration: value, editField: 'assignee' })
  }

  _onChangeAssignee (opt) {
    this.setState({
      assignee: opt.label,
      assigneeId: opt.value,
      editField: 'description'
    })
  }

  _onKeyDownField (name, ev) {
    if (
      ev.keyCode === 9 ||
      (ev.keyCode === 13 && name !== 'duration' && name !== 'assignee')
    ) {
      ev.preventDefault()

      if ((ev.keyCode === 13 && name === 'title') || name === 'description') {
        this._saveTask()
      } else {
        const stateObj = {}
        let nextField = 'duedate'
        if (name === 'duedate') {
          nextField = 'duration'
        } else if (name === 'duration') {
          if (this._references.duration.current) {
            stateObj.duration = this._references.duration.current.getValueInMintues()
          }
          nextField = 'assignee'
        } else if (name === 'assignee') {
          nextField = 'description'
        }

        stateObj.editField = nextField
        this.setState(stateObj)
      }
    }
  }

  _onChangeDueDate (value) {
    if (value && value instanceof Date && !isNaN(value.getTime())) {
      this.setState({ duedate: value, editField: 'duration' })
    }
  }

  /* Other Render Functions */
  _renderFieldInfo (name, value) {
    return (
      <div className={`col ${name}`}>
        <div className={name} onClick={this._onClickField.bind(this, name)}>
          {value}
        </div>
      </div>
    )
  }

  _renderFieldTitle () {
    const { editField, title } = this.state

    if (editField !== 'title') {
      return this._renderFieldInfo('title', title)
    }

    return (
      <div className='title_editable'>
        <FieldText
          name='title'
          value={title}
          showEdit={false}
          autoFocus
          onChange={this._onChangeInput.bind(this, 'title')}
          onKeyDown={this._onKeyDownField.bind(this, 'title')}
        />
      </div>
    )
  }

  _renderFieldDueDate () {
    const { editField, duedate } = this.state

    if (editField !== 'duedate') {
      const displayDate = DateUtil.getDisplayDate(duedate)
      return this._renderFieldInfo('duedate', displayDate)
    }

    return (
      <div className='duedate_editable'>
        <FormDatePicker
          ref={this._references.duedate}
          alwaysShowMask
          maskChar='_'
          placeholder='project.form.noStartDatePlaceholder'
          value={duedate}
          name='duedate'
          onChange={this._onChangeDueDate.bind(this)}
          onKeyDown={this._onKeyDownField.bind(this, 'duedate')}
        />
      </div>
    )
  }

  _renderFieldDuration () {
    const { editField, duration } = this.state

    if (editField !== 'duration') {
      return this._renderFieldInfo(
        'duration',
        Util.convertMinutesToHour(duration || 0)
      )
    }

    return (
      <div className='duration_editable'>
        <FieldTime
          ref={this._references.duration}
          name='duration'
          value={duration}
          showEdit={false}
          onChange={this._onChangeDuration.bind(this)}
          onKeyDown={this._onKeyDownField.bind(this, 'duration')}
        />
      </div>
    )
  }

  _renderFieldAssignee () {
    const { users } = this.props
    const { editField, assignee } = this.state

    if (editField !== 'assignee') {
      return this._renderFieldInfo('assignee', assignee)
    }

    /* const MenuList = (props) => {
      return (
        <components.MenuList {...props}>
          <div className="menulist">
            Custom Menu List
          </div>
          {props.children}
        </components.MenuList>
      );
    }; */

    let selectedUser = ''
    users.forEach(user => {
      if (user.label === assignee) {
        selectedUser = user.value
      }
    })

    return (
      <div
        className={`assignee_editable${editField === assignee ? ' full' : ''}`}
      >
        <FieldSelect
          name='assignee'
          options={users}
          value={selectedUser}
          components={{ Option: this._renderOption }}
          onChange={this._onChangeAssignee.bind(this)}
          onKeyDown={this._onKeyDownField.bind(this, 'assignee')}
        />
      </div>
    )
  }

  _renderOption = option => {
    const { users } = this.props
    let userImage = ''

    users.forEach(user => {
      if (user.value === option.value) {
        userImage = user.imageUrl
      }
    })

    return (
      <div
        className={classnames('css-v73v8k', 'cselect__option', {
          'cselect__option--is-focused': option.isFocused,
          'cselect__option--is-selected': users.indexOf(option.value) >= 0
        })}
        onClick={this._onChangeAssignee.bind(this, option)}
      >
        <span className='image'>
          <Avatar imageUrl={userImage} />
        </span>
        <span className='selecttitle'>{option.label}</span>
      </div>
    )
  }

  _renderFieldDescription () {
    const { editField, description } = this.state

    if (editField === 'assignee') {
      return null
    } else if (editField !== 'description') {
      return this._renderFieldInfo('description', description)
    }

    return (
      <div className='description_editable'>
        <FieldText
          name='description'
          value={description}
          showEdit={false}
          autoFocus
          onChange={this._onChangeInput.bind(this, 'description')}
          onKeyDown={this._onKeyDownField.bind(this, 'description')}
        />
      </div>
    )
  }

  /* Render Function */
  render () {
    return (
      <div className='task-quick-add'>
        <div className='imgcont'>
          <IconButton
            icon='+'
            size='big'
            className='addtask'
            type='secondary'
          />
          <FieldTitle title='Quick Add' />
        </div>
        <div className='quick-add-cont'>
          <div className='row fieldcont'>
            {this._renderFieldTitle()}
            {this._renderFieldDueDate()}
            {this._renderFieldDuration()}
            {this._renderFieldAssignee()}
            {this._renderFieldDescription()}
          </div>
          <div className='row headercont'>
            <div className='col title'>
              <FieldTitle title='Title' />
            </div>
            <div className='col duedate'>
              <FieldTitle title='plannerv2.task.editDuedate' />
            </div>
            <div className='col duration'>
              <FieldTitle title='duration hours' />
            </div>
            <div className='col assignee'>
              <FieldTitle title='Assignee' />
            </div>
            <div className='col description'>
              <FieldTitle title='plannerv2.task.editDescription' />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PlannerTaskQuickAdd
